module.exports = __webpack_public_path__ + "static/Trodl-13dc84358cc2e7596191fd605ae26ded.png";